var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['font-weight-bold','text-capitalize', _vm.condition]},[_vm._v("\n  "+_vm._s(_vm.condition)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }